import React from 'react';
import { Image, Badge } from 'react-bootstrap';
import Text from 'react-format-text';
import {observer} from 'mobx-react';
import ImageAttachments from './ImageAttachments';


function Card({card, onClick}){
  const {attachments} = card;
  return(
    <div className={"note card relative-position "+ (card.selected? "selected":"")} onClick={onClick}>
      { ( card.name && card.name != " " )  && (
        <Badge className="name">{card.name}</Badge>
      )}
      <div className="description">
        <Text>{card.description}</Text>
      </div>
      <ImageAttachments attachments={attachments} />
    </div>
  );
}



export default(observer(Card));